import React, { useState, useEffect, useRef } from 'react';
import PriceBadge from './PriceBadge';

const BackIcon = () => (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.75 6.27344C15.1642 6.27344 15.5 5.93765 15.5 5.52344C15.5 5.10922 15.1642 4.77344 14.75 4.77344V5.52344V6.27344ZM0.21967 4.99311C-0.0732231 5.286 -0.0732231 5.76087 0.21967 6.05377L4.99264 10.8267C5.28553 11.1196 5.76041 11.1196 6.0533 10.8267C6.34619 10.5338 6.34619 10.059 6.0533 9.76608L1.81066 5.52344L6.0533 1.2808C6.34619 0.987904 6.34619 0.51303 6.0533 0.220137C5.76041 -0.0727568 5.28553 -0.0727568 4.99264 0.220137L0.21967 4.99311ZM14.75 5.52344V4.77344L0.75 4.77344V5.52344V6.27344L14.75 6.27344V5.52344Z" fill="currentColor"/>
    </svg>
);

const PrintIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 6.25V3.125H15V6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15 11.875H5V16.875H15V11.875Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M5 13.75H1.875V7.5C1.875 6.80937 2.48125 6.25 3.22891 6.25H16.7711C17.5187 6.25 18.125 6.80937 18.125 7.5V13.75H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.6875 10C15.2053 10 15.625 9.58027 15.625 9.0625C15.625 8.54473 15.2053 8.125 14.6875 8.125C14.1697 8.125 13.75 8.54473 13.75 9.0625C13.75 9.58027 14.1697 10 14.6875 10Z" fill="currentColor"/>
    </svg>
);

const StarIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.53834 2.10996C9.70914 1.69932 10.2909 1.69932 10.4617 2.10996L12.2632 6.4415C12.3353 6.61462 12.4981 6.7329 12.685 6.74789L17.3612 7.12278C17.8045 7.15832 17.9843 7.71158 17.6465 8.00091L14.0837 11.0528C13.9413 11.1748 13.8791 11.3662 13.9226 11.5486L15.0111 16.1118C15.1143 16.5444 14.6437 16.8864 14.2642 16.6545L10.2606 14.2092C10.1006 14.1115 9.89938 14.1115 9.73937 14.2092L5.73584 16.6545C5.35629 16.8864 4.88567 16.5444 4.98886 16.1118L6.07736 11.5486C6.12086 11.3662 6.05868 11.1748 5.91628 11.0528L2.35347 8.00091C2.0157 7.71157 2.19546 7.15832 2.63879 7.12278L7.31505 6.74789C7.50194 6.7329 7.66475 6.61462 7.73675 6.4415L9.53834 2.10996Z" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
);

const ShareIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.4168 15.525C3.70274 14.1555 7.07852 11.25 11.8754 11.25V13.3085C11.8754 14.2355 13.0275 14.6635 13.6328 13.9614L16.9996 10.0559C17.6465 9.30547 17.6465 8.19453 16.9996 7.44412L13.6328 3.5386C13.0275 2.83647 11.8754 3.26453 11.8754 4.19154V6.25C7.7504 6.25 2.46212 10.1914 1.8754 15.2766C1.86728 15.3424 1.88032 15.4091 1.91265 15.4671C1.94498 15.525 1.99491 15.5712 2.05522 15.5988C2.11552 15.6265 2.18307 15.6343 2.24807 15.621C2.31308 15.6077 2.37218 15.5741 2.4168 15.525Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const BookmarkIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 2.5H15C15.4142 2.5 15.75 2.83579 15.75 3.25V17.25L10 14L4.25 17.25V3.25C4.25 2.83579 4.58579 2.5 5 2.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

function IconButton({ onClick, title, children, className = '' }) {
    return (
        <button
            type="button"
            onClick={onClick}
            title={title}
            className={`inline-flex items-center justify-center w-[32px] h-[32px] text-[#636369] hover:text-[#111827] transition-colors flex-shrink-0 ${className}`}
        >
            {children}
        </button>
    );
}

export default function DetailStickyHeader({ scrollRef, isVisible, detail, market, onBack, onSave, onFollow, isFollowed, onPrint, onShare }) {
    const [isRevealed, setIsRevealed] = useState(false);
    const headerRef = useRef(null);

    useEffect(() => {
        const el = scrollRef?.current;
        if (!el || !isVisible) return;

        let lastScrollTop = el.scrollTop;
        const onScroll = () => {
            const currentScrollTop = el.scrollTop;
            const diff = currentScrollTop - lastScrollTop;

            if (diff < -15) {
                setIsRevealed(true);
            } else if (diff > 15) {
                setIsRevealed(false);
            }
            lastScrollTop = currentScrollTop;
        };

        el.addEventListener('scroll', onScroll);
        return () => el.removeEventListener('scroll', onScroll);
    }, [scrollRef, isVisible]);

    const activeReveal = isVisible && isRevealed;

    const symbol = detail?.symbol || '';
    const price = market?.priceClose ?? detail?.structured?.price ?? null;
    const changePct = market?.pctChange ?? market?.pricePctChgIntraDay ?? detail?.structured?.change_pct ?? null;

    return (
        <>
            {isVisible && !activeReveal && (
                <div
                    className="absolute top-0 left-0 right-0 h-[60px] z-40"
                    onMouseEnter={() => setIsRevealed(true)}
                />
            )}

            <div
                ref={headerRef}
                className={`absolute top-0 left-0 right-0 bg-white border-b border-[#DEDEDE] z-30 transition-all duration-300 ease-in-out transform ${
                    activeReveal ? 'translate-y-0 opacity-100 shadow-sm' : '-translate-y-full opacity-0 pointer-events-none'
                }`}
                onMouseLeave={() => setIsRevealed(false)}
            >
                <div className="h-[48px] flex items-center justify-between max-w-[1472px] mx-auto px-[12px] md:px-[32px]">
                    <div className="flex items-center gap-[8px] min-w-0">
                        <button
                            type="button"
                            onClick={onBack}
                            className="inline-flex items-center justify-center w-[32px] h-[32px] text-[#636369] hover:text-[#111827] transition-colors flex-shrink-0"
                        >
                            <BackIcon />
                        </button>
                        {symbol && (
                            <span className="text-[14px] font-bold text-[#111827] flex-shrink-0">{symbol}</span>
                        )}
                        <PriceBadge price={price} changePct={changePct} className="inline-flex items-center px-[8px] py-[3px] rounded-[6px] border flex-shrink-0" />
                    </div>

                    <div className="flex items-center gap-[4px] flex-shrink-0">
                        <IconButton title="Lưu" onClick={onSave}><BookmarkIcon /></IconButton>
                        <IconButton title={isFollowed ? 'Bỏ theo dõi' : 'Theo dõi'} onClick={onFollow} className={isFollowed ? 'text-[#F59E0B]' : ''}><StarIcon /></IconButton>
                        <IconButton title="In / Lưu PDF" onClick={onPrint}><PrintIcon /></IconButton>
                        <IconButton title="Chia sẻ" onClick={onShare}><ShareIcon /></IconButton>
                    </div>
                </div>
            </div>
        </>
    );
}
